export const STATUS_PENDING = 'pending';
export const STATUS_FAILED = 'failed';
export const STATUS_IDLE = 'idle';
